import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../../hooks/useStore';
import { DataViewEditBox } from '../../../../lib/components';
import { DataGrid, DataGridElement } from '../../../../lib/components/compound/dataGrid';
import { link } from '../../../../misc/globals';

export const CompanyGeneralSecurity: FC = observer(() => {
  const { t } = useTranslation();
  const { companyStore } = useStore();

  const renderView = observer(() => {
    return (
      <DataGrid>
        <DataGridElement
          title={t('company:DATA_PROTECTION')}
          value={link.privacy_policy}
          type="url"
          xs={12}
        />
        <DataGridElement
          title={t('company:ORDER_DATA_PROCESSING')}
          value={companyStore.generalData?.avv_url}
          type="url"
          xs={12}
        />
      </DataGrid>
    );
  });

  return (
    <DataViewEditBox
      title={t('company:DATA_PROTECTION')}
      canSubmit={false}
      canEdit={false}
      view={renderView}
      edit={() => <></>}
    />
  );
});
